//REGISTER
export const POST_FAKE_REGISTER = "/post-fake-register";

//LOGIN
export const POST_FAKE_LOGIN = "login"; //"/post-fake-login";
export const POST_INFO_USER = "/users/users-info";
export const GET_USERS = "brokers?group_id={group_id}";

export const GET_SCHEDULES = "brokers/{broker_id}/schedules";
export const UPDATE_SCHEDULES = "brokers/{broker_id}/schedules";
export const GET_INFO_USER = "brokers/{broker_id}";


export const GET_USER = "/users/{id_user}";
export const GET_USER_INFO = "/users-configuration/users-info"; // este lleva más parametros
export const GET_INTERVIEWERS = "/users/interviewers";


//PROFILE
export const URL_USER_CONFIGURATION = "/users-configuration";
export const EDIT_USER_CONFIGURATION = "/users-configuration/{id_user_configuration}";
export const URL_USER_ROLE = "/users-role";
export const EDIT_USER_ROLE = "/users-role/{id_user_role}";

//Roles
export const URL_ROLES = "/roles";
export const EDIT_ROLES = "/roles/{id_role}";


export const GET_CONVERSATIONS_NOT_JOINED= "conversations/not-joined";
export const GET_CHAT_TOKEN_TWILIO="token"; 
export const GET_CONVERSATIONS_JOIN= "conversations/join";
export const GET_MEDIA_TWILIO = "conversations/media"; 

export const ADD_SEND_MEDIA = "conversations/send-media"; 
export const UPDATE_AGENT = "hitl/config"; 
export const GET_STATUS_AGENT = "hitl/config?conversation_sid={id_channel}&org_id={id_org}"; 
export const ADD_SEND_MESSAGE = "hitl/inject"; 
export const UPDATE_ATTRIBUTE_CHANNEL = "update-attributes/{id_channel}"; 
export const UPDATE_NAME_CONTACT = "rename-contact"; 

// Plantillas
export const GET_TEMPLATES = "templates?group_id={id_group}"; 
export const POST_TEMPLATES = "conversations/{id_channel}/messages/templates"; 
export const POST_ASSIGN_USER = "conversations/{conversation_sid}/broker";
export const UPDATE_NOTES = "conversations/{conversation_sid}/notes";
export const GET_NOTES = "conversations/{conversation_sid}/notes?org_id={org_id}&whatsapp_number={whatsapp}";
